import * as Keycloak from 'keycloak-js/dist/keycloak';

export default class KeycloakService {
    static baseConfig = {
        // TODO: inject realm
        realm: __KEYCLOAK_REALM__,
        url: "https://sso.tractsoft.io/auth",
        sslRequired: "external",
        resource: __KEYCLOAK_RESOURCE__,
        publicClient: true,
        confidentialPort: 0,
        clientId: __KEYCLOAK_CLIENT_ID__
    } as Keycloak.KeycloakInitOptions;

    static keycloakLoginOptions : Keycloak.KeycloakLoginOptions = {};
    // TODO: inject IDP hint
    // if <fetch idp hint from metadata db> { keycloakLoginOptions = {idpHint: idpHint} }

    private client : Keycloak.KeycloakInstance = Keycloak(KeycloakService.baseConfig);

    public init(moreOptions?: Keycloak.KeycloakInitOptions): Promise<boolean> {
        return new Promise((resolve, reject) => {
            let initOptions : Keycloak.KeycloakInitOptions = {
                checkLoginIframe: false,
                redirectUri: window.location.origin,
                // responseMode: "query"
            };

            if (moreOptions && moreOptions.token) {
                initOptions.token = moreOptions.token;
                initOptions.refreshToken = moreOptions.refreshToken;
                initOptions.idToken = moreOptions.idToken;
            }

            this.client.init(initOptions)
                .success((authorized: boolean) => {
                    resolve(authorized);
                })
                .error((errorData: any) => {
                    reject(errorData);
                });
        });
    }

    public login() {
        // This will redirect, so no point in returning a promise.
        this.client.login();
    }

    public tokens() {
        return {
            token: this.client.token,
            refreshToken: this.client.refreshToken,
            idToken: this.client.idToken,
        }
    }

    public updateToken(): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            if (this.client.token) {
                this.client.updateToken(30)
                    .success(() => {
                        resolve(this.client.token);
                    })
                    .error(() => {
                        reject('Failed to refresh token.');
                    });
            } else {
                reject('Not logged in.');
            }
        });
    }
}



// WEBPACK FOOTER //
// ./services/KeycloakService.tsx